const hasCap = (caps, cap) => {
    if(
        cap && 
        caps && 
        caps.hasOwnProperty(cap) && 
        caps[cap]
    ) {
        return true  
    } else {
        return false
    }
}

export default hasCap